/** @format */

import { useNavigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Typography } from '@mui/material';
// components
import Page from '../../components/Page';
import LoginForm from './LoginForm';
import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import logo from '../../static/logo-infomedia.png'; // relative path to image

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const navigate = useNavigate();
  let token = useSelector(({ auth }) => auth?.auth?.token);
  useEffect(() => {
    if (token) {
      navigate('/', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <RootStyle title="Login">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <img src={logo} alt="logo-infomedia" />
          </Stack>
          <LoginForm />
          <Typography mt={3}>
            Don't have an account?{' '}
            <span
              onClick={() => navigate('/register')}
              style={{ color: 'blue', cursor: 'pointer', fontWeight: '700' }}
            >
              Sign up.
            </span>
          </Typography>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
